// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__JpHKF","content":"Landing_content__d+96U","title":"Landing_title__lYcCu","test":"Landing_test__-RItV"};